function SwimmingIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M28.5 15C29.6046 15 30.5 14.1046 30.5 13C30.5 11.8954 29.6046 11 28.5 11C27.3954 11 26.5 11.8954 26.5 13C26.5 14.1046 27.3954 15 28.5 15ZM28.5 17C30.7091 17 32.5 15.2091 32.5 13C32.5 10.7909 30.7091 9 28.5 9C26.2909 9 24.5 10.7909 24.5 13C24.5 15.2091 26.2909 17 28.5 17Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0.5 21C0.5 20.4477 0.947715 20 1.5 20C3.43446 20 4.45659 20.9806 5.27685 21.7676C5.28671 21.777 5.29655 21.7865 5.30635 21.7959C6.13962 22.5951 6.85381 23.2598 8.30082 23.2598C9.74783 23.2598 10.462 22.5951 11.2953 21.7959L11.3 21.7914C11.3102 21.7816 11.3204 21.7718 11.3307 21.7619C12.1491 20.9779 13.1699 20 15.1016 20C17.0362 20 18.0571 20.9795 18.8768 21.766L18.9076 21.7955C19.7408 22.5947 20.4555 23.2598 21.9025 23.2598C23.3495 23.2598 24.0637 22.5951 24.8969 21.7959L24.9014 21.7916L24.9324 21.7619C25.7508 20.9779 26.7716 20 28.7033 20C29.2556 20 29.7033 20.4477 29.7033 21C29.7033 21.5523 29.2556 22 28.7033 22C27.6004 22 27.0867 22.4681 26.2849 23.2359L26.2602 23.2595C25.3913 24.0931 24.175 25.2598 21.9025 25.2598C19.6299 25.2598 18.4137 24.0931 17.5447 23.2595L17.5237 23.2394C16.7205 22.4691 16.2064 22 15.1016 22C13.9988 22 13.485 22.4681 12.6833 23.2359L12.6586 23.2595C11.7896 24.0931 10.5734 25.2598 8.30082 25.2598C6.02827 25.2598 4.81203 24.0931 3.94307 23.2595C3.93601 23.2528 3.92898 23.246 3.92198 23.2393C3.1188 22.469 2.60384 22 1.5 22C0.947715 22 0.5 21.5523 0.5 21Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0.5 26C0.5 25.4477 0.947715 25 1.5 25C3.43446 25 4.45659 25.9806 5.27685 26.7676C5.28671 26.777 5.29655 26.7865 5.30635 26.7959C6.13962 27.5951 6.85381 28.2598 8.30082 28.2598C9.74783 28.2598 10.462 27.5951 11.2953 26.7959L11.3 26.7914C11.3102 26.7816 11.3204 26.7718 11.3307 26.7619C12.1491 25.9779 13.1699 25 15.1016 25C17.0362 25 18.0571 25.9795 18.8768 26.766L18.9076 26.7955C19.7408 27.5947 20.4555 28.2598 21.9025 28.2598C23.3495 28.2598 24.0637 27.5951 24.8969 26.7959L24.9014 26.7916L24.9324 26.7619C25.7508 25.9779 26.7716 25 28.7033 25C29.2556 25 29.7033 25.4477 29.7033 26C29.7033 26.5523 29.2556 27 28.7033 27C27.6004 27 27.0867 27.4681 26.2849 28.2359L26.2602 28.2595C25.3913 29.0931 24.175 30.2598 21.9025 30.2598C19.6299 30.2598 18.4137 29.0931 17.5447 28.2595L17.5237 28.2394C16.7205 27.4691 16.2064 27 15.1016 27C13.9988 27 13.485 27.4681 12.6833 28.2359L12.6586 28.2595C11.7896 29.0931 10.5734 30.2598 8.30082 30.2598C6.02827 30.2598 4.81203 29.0931 3.94307 28.2595C3.93601 28.2528 3.92898 28.246 3.92198 28.2393C3.1188 27.469 2.60384 27 1.5 27C0.947715 27 0.5 26.5523 0.5 26Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.0296 10.1178C19.4881 9.87324 20.0575 10.0206 20.3398 10.4569L25.8398 18.9569C26.1398 19.4206 26.0071 20.0397 25.5434 20.3397C25.0798 20.6397 24.4607 20.5071 24.1606 20.0434L19.1599 12.315L4.97079 19.8825C4.48348 20.1424 3.87774 19.958 3.61784 19.4707C3.35795 18.9834 3.5423 18.3777 4.02961 18.1178L19.0296 10.1178Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M26.9878 4.84418C27.0739 5.38971 26.7015 5.90177 26.156 5.98791L18.198 7.24442L20.3321 10.4454C20.6384 10.905 20.5142 11.5258 20.0547 11.8322C19.5952 12.1385 18.9743 12.0144 18.668 11.5548L15.668 7.05485C15.4789 6.77125 15.4473 6.41087 15.5841 6.0987C15.721 5.78652 16.0074 5.56554 16.344 5.51238L25.844 4.01238C26.3896 3.92625 26.9016 4.29866 26.9878 4.84418Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default SwimmingIcon;
